export default "__VITE_ASSET__fbabb423__"